import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import { Image, VideoModule } from '@app/models/content';
import { ViewEncapsulation } from '@angular/core';
import { ToolsService } from '@app/services/tools/tools.service';
import { EventsService } from '@app/services/events/events.service';
import Player = YT.Player;

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VideoComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() module: VideoModule;

  isShowPlayer = false;
  videoDomId: string;
  player: Player;
  playerAppended = false;
  playerReady = false;
  thumbnail: Image;

  constructor(
    private toolsService: ToolsService,
    private events: EventsService
  ) {}

  ngOnInit() {
    this.videoDomId = 'video-module__iframe--' + this.module.video.videoId + '-' + this.module.finalSlug;
    this.events.on('youtube-iframe-api-ready', this.onYoutubeIframeAPIReady);
    this.thumbnail = this.module.video.image ? this.module.video.image : {
      url: `https://img.youtube.com/vi/${this.module.video.videoId}/maxresdefault.jpg`,
      alt: this.module.video.title
    };
  }

  ngAfterViewInit(): void {
    if (!this.playerAppended && this.toolsService.isYouTubeIframeAPIReady) {
      this.appendPlayer();
    }
  }

  ngOnDestroy(): void {
    this.events.off('youtube-iframe-api-ready', this.onYoutubeIframeAPIReady);
  }

  onYoutubeIframeAPIReady = () => {
    if (!this.playerAppended) { this.appendPlayer(); }
  }

  appendPlayer() {
    this.player = new YT.Player(this.videoDomId, {
      videoId: this.module.video.videoId,
      playerVars: {
        playsinline: 1
      },
      events: {
        onReady: () => {
          this.playerReady = true;
          if (this.isShowPlayer) { this.playVideo(); }
        }
      }
    });
    this.playerAppended = true;
  }

  showPlayer() {
    this.isShowPlayer = true;
    if (this.playerReady) { this.playVideo(); }
  }

  playVideo() {
    this.player.playVideo();
  }
}
